import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Modal from 'react-modal';
import Payment from './Payment';
import { ErrorMessage } from '../../common';
import { fetchPaymentMethods } from '../../../actions/ClientData';
import { TRootState } from '../../../reducers';

export default function PaymentModal() {

    const dispatch = useDispatch();

    const {
        basicInfo,
        error,
    } = useSelector((state: TRootState) => ({
        basicInfo: state.clientData.basicInfo,
        error: state.clientData.error,
    }));

    useEffect(() => {
        dispatch(fetchPaymentMethods(basicInfo.id, 'OK'));
    }, []);

    const createErrorMessage = (errorProp: any) => {
        if (errorProp.hasOwnProperty('payment_method')) {
            const msg = errorProp.payment_method.payment_method.toLowerCase();
            return `Payment method ${msg}`;
        }
        return errorProp;
    };

    return (
        <Modal
            className="payment-modal"
            contentLabel="Payment Modal"
            isOpen={true}
        >
            <p className="modal-title small">Authorize booking</p>
            <Payment className="modal-content"/>
            <div>
                {error.confirmJob != null && (
                    <ErrorMessage message={createErrorMessage(error.confirmJob)}/>
                )}
            </div>
        </Modal>
    );
}
